export default __webpack_public_path__ + "static/media/hide.e3190a3c.svg";